import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import { formatShieldUrl } from '../../common/models/Rival';
const dayjs = window.dayjs;
const WEEKDAYS = {
  es: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
  eu: ['Al', 'Ar', 'Az', 'Og', 'Or', 'La', 'Ig'],
  en: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
};
const WEEKDAYS_FULL = {
  es: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
  eu: ['Astelehena', 'Asteartea', 'Asteazkena', 'Osteguna', 'Ostirala', 'Larunbata', 'Igandea'],
  en: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
};
const MONTHS_SHORT = {
  es: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  eu: ['Urt', 'Ots', 'Mar', 'Api', 'Mai', 'Eka', 'Uzt', 'Abu', 'Ira', 'Urr', 'Aza', 'Abe'],
  en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
};
const MONTHS_FULL = {
  es: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
  eu: ['Urtarrila', 'Otsaila', 'Martxoa', 'Apirila', 'Maiatza', 'Ekaina', 'Uztaila', 'Abuztua', 'Iraila', 'Urria', 'Azaroa', 'Abendua'],
  en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
export default class CalendarMonthView extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "currentYear", 2026);
    _defineProperty(this, "currentMonth", 9);
    // 0-indexed: 9 = October
    _defineProperty(this, "selectedMatch", null);
    _defineProperty(this, "monthsBarRef", null);
    _defineProperty(this, "lastSeenPropMatchId", null);
    _defineProperty(this, "shouldScrollQuickBar", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    const now = new Date();
    this.currentYear = now.getFullYear();
    this.currentMonth = now.getMonth();
    this.lastSeenPropMatchId = vnode.attrs.selectedMatchId ? String(vnode.attrs.selectedMatchId) : null;
    this.initMonthFromData(vnode.attrs);
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    const newPropId = vnode.attrs.selectedMatchId ? String(vnode.attrs.selectedMatchId) : null;
    // Only react if parent passed a different selectedMatchId
    if (newPropId && newPropId !== this.lastSeenPropMatchId) {
      this.lastSeenPropMatchId = newPropId;
      const found = (vnode.attrs.matches || []).find(m => String(m.id()) === newPropId);
      if (found) {
        this.selectedMatch = found;
        this.focusMatchMonth(found);
      }
    } else if (!newPropId && this.lastSeenPropMatchId) {
      this.lastSeenPropMatchId = null;
    }
  }
  initMonthFromData(attrs) {
    const matches = attrs.matches || [];

    // 1. If anchor or pre-selected match
    if (attrs.selectedMatchId) {
      const match = matches.find(m => String(m.id()) === String(attrs.selectedMatchId));
      if (match) {
        this.selectedMatch = match;
        this.focusMatchMonth(match);
        return;
      }
    }

    // 2. If next match is in season, focus on it
    if (attrs.featuredNextMatch) {
      const d = this.getMatchDateObj(attrs.featuredNextMatch);
      if (d) {
        this.currentYear = d.getFullYear();
        this.currentMonth = d.getMonth();
        this.selectedMatch = attrs.featuredNextMatch;
        return;
      }
    }

    // 3. If last match exists and today's month has no matches
    const matchesThisMonth = this.getMatchesForYearMonth(this.currentYear, this.currentMonth, matches);
    if (matchesThisMonth.length === 0 && attrs.featuredLastMatch) {
      const d = this.getMatchDateObj(attrs.featuredLastMatch);
      if (d) {
        this.currentYear = d.getFullYear();
        this.currentMonth = d.getMonth();
        this.selectedMatch = attrs.featuredLastMatch;
        return;
      }
    }

    // 4. Default: first match of season if any matches exist
    if (matches.length > 0 && matchesThisMonth.length === 0) {
      const firstWithDate = matches.find(m => this.getMatchDateObj(m));
      if (firstWithDate) {
        const d = this.getMatchDateObj(firstWithDate);
        if (d) {
          this.currentYear = d.getFullYear();
          this.currentMonth = d.getMonth();
        }
      }
    }
  }
  getMatchDateObj(m) {
    if (!m) return null;
    const raw = typeof m.matchDate === 'function' ? m.matchDate() : m.matchDate;
    if (!raw) return null;
    if (raw instanceof Date) return isNaN(raw.getTime()) ? null : raw;
    const d = new Date(raw);
    return isNaN(d.getTime()) ? null : d;
  }
  focusMatchMonth(match) {
    if (!match) return;
    const d = this.getMatchDateObj(match);
    if (d) {
      this.currentYear = d.getFullYear();
      this.currentMonth = d.getMonth();
    }
  }
  prevMonth() {
    if (this.currentMonth === 0) {
      this.currentMonth = 11;
      this.currentYear--;
    } else {
      this.currentMonth--;
    }
    this.selectedMatch = null;
    this.lastSeenPropMatchId = null;
    this.shouldScrollQuickBar = true;
    if (this.attrs.onSelectMatch) {
      this.attrs.onSelectMatch(null);
    }
    m.redraw();
  }
  nextMonth() {
    if (this.currentMonth === 11) {
      this.currentMonth = 0;
      this.currentYear++;
    } else {
      this.currentMonth++;
    }
    this.selectedMatch = null;
    this.lastSeenPropMatchId = null;
    this.shouldScrollQuickBar = true;
    if (this.attrs.onSelectMatch) {
      this.attrs.onSelectMatch(null);
    }
    m.redraw();
  }
  goToToday() {
    const now = new Date();
    this.currentYear = now.getFullYear();
    this.currentMonth = now.getMonth();
    this.selectedMatch = null;
    this.lastSeenPropMatchId = null;
    this.shouldScrollQuickBar = true;
    if (this.attrs.onSelectMatch) {
      this.attrs.onSelectMatch(null);
    }
    m.redraw();
  }
  goToNextMatch() {
    if (this.attrs.featuredNextMatch) {
      this.selectedMatch = this.attrs.featuredNextMatch;
      this.lastSeenPropMatchId = String(this.attrs.featuredNextMatch.id());
      this.shouldScrollQuickBar = true;
      this.focusMatchMonth(this.attrs.featuredNextMatch);
      if (this.attrs.onSelectMatch) {
        this.attrs.onSelectMatch(this.attrs.featuredNextMatch);
      }
      m.redraw();
    }
  }
  setYearMonth(year, month) {
    this.currentYear = year;
    this.currentMonth = month;
    this.selectedMatch = null;
    this.lastSeenPropMatchId = null;
    this.shouldScrollQuickBar = true;
    if (this.attrs.onSelectMatch) {
      this.attrs.onSelectMatch(null);
    }
    m.redraw();
  }
  getLang() {
    const loc = app.translator && app.translator.locale ? app.translator.locale.toLowerCase() : 'es';
    if (loc.startsWith('eu')) return 'eu';
    if (loc.startsWith('en')) return 'en';
    return 'es';
  }
  getMonthTitle(year, month) {
    const lang = this.getLang();
    const monthName = MONTHS_FULL[lang][month] || MONTHS_FULL.es[month];
    return "".concat(monthName, " ").concat(year);
  }
  getMatchesForYearMonth(year, month, matches) {
    return (matches || []).filter(m => {
      const d = this.getMatchDateObj(m);
      if (!d) return false;
      return d.getFullYear() === year && d.getMonth() === month;
    });
  }
  getSeasonMonthsList() {
    const matches = this.attrs.matches || [];
    const seasonName = this.attrs.selectedSeasonName || '';
    let startYear = this.currentYear;
    let endYear = this.currentYear;

    // Try extracting years from "2026/2027" or "2026-2027"
    const yearMatch = seasonName.match(/(\d{4})[\/\-](\d{4})/);
    if (yearMatch) {
      startYear = parseInt(yearMatch[1], 10);
      endYear = parseInt(yearMatch[2], 10);
    } else if (matches.length > 0) {
      const dates = matches.map(m => this.getMatchDateObj(m)).filter(Boolean).map(d => d.getTime());
      if (dates.length > 0) {
        startYear = new Date(Math.min(...dates)).getFullYear();
        endYear = new Date(Math.max(...dates)).getFullYear();
      }
    }

    // Build list: August of startYear to June of endYear
    const monthsList = [];
    const lang = this.getLang();
    let y = startYear;
    let m = 7; // August = 7 (0-indexed)
    const stopY = endYear;
    const stopM = 5; // June = 5

    while (y < stopY || y === stopY && m <= stopM) {
      const count = this.getMatchesForYearMonth(y, m, matches).length;
      const shortLabel = MONTHS_SHORT[lang][m] || MONTHS_SHORT.es[m];
      monthsList.push({
        year: y,
        month: m,
        label: "".concat(shortLabel, " '").concat(String(y).slice(-2)),
        count
      });
      m++;
      if (m > 11) {
        m = 0;
        y++;
      }
    }
    return monthsList;
  }
  renderMonthsQuickBar() {
    const monthsList = this.getSeasonMonthsList();
    return m("div", {
      className: "CalendarMonthView-quickBar",
      oncreate: vnode => {
        const activeEl = vnode.dom.querySelector('.is-active');
        if (activeEl) {
          activeEl.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      },
      onupdate: vnode => {
        if (this.shouldScrollQuickBar) {
          this.shouldScrollQuickBar = false;
          const activeEl = vnode.dom.querySelector('.is-active');
          if (activeEl) {
            activeEl.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center'
            });
          }
        }
      }
    }, monthsList.map(item => {
      const isActive = item.year === this.currentYear && item.month === this.currentMonth;
      return m("button", {
        type: "button",
        className: "CalendarMonthView-quickPill ".concat(isActive ? 'is-active' : '', " ").concat(item.count > 0 ? 'has-matches' : 'no-matches'),
        onclick: e => {
          e.preventDefault();
          e.stopPropagation();
          this.setYearMonth(item.year, item.month);
        },
        title: "".concat(this.getMonthTitle(item.year, item.month), " (").concat(item.count, " partidos)")
      }, m("span", {
        className: "CalendarMonthView-quickPill-label"
      }, item.label), item.count > 0 && m("span", {
        className: "CalendarMonthView-quickPill-badge"
      }, item.count));
    }));
  }
  renderMonthStats(matchesInMonth) {
    if (!matchesInMonth.length) return null;
    const homeMatches = matchesInMonth.filter(m => typeof m.isLocal === 'function' ? m.isLocal() : true);
    const awayMatches = matchesInMonth.filter(m => typeof m.isLocal === 'function' ? !m.isLocal() : false);
    const playedMatches = matchesInMonth.filter(m => {
      const scoreA = typeof m.scoreAthletic === 'function' ? m.scoreAthletic() : m.scoreAthletic;
      return scoreA !== null && scoreA !== undefined && scoreA !== '';
    });
    let wins = 0;
    let draws = 0;
    let losses = 0;
    playedMatches.forEach(m => {
      const outcome = this.attrs.getMatchOutcome(m);
      if (outcome === 'win') wins++;else if (outcome === 'draw') draws++;else if (outcome === 'loss') losses++;
    });
    return m("div", {
      className: "CalendarMonthView-statsBar"
    }, m("div", {
      className: "CalendarMonthView-statsItem"
    }, m("i", {
      className: "far fa-calendar-check",
      style: "color: #ee2524;"
    }), m("span", null, m("strong", null, matchesInMonth.length), " ", matchesInMonth.length === 1 ? 'partido' : 'partidos')), m("div", {
      className: "CalendarMonthView-statsItem"
    }, m("span", null, "\uD83C\uDFE0 ", m("strong", null, homeMatches.length), " en San Mam\xE9s"), m("span", {
      className: "separator"
    }, "\u2022"), m("span", null, "\u2708\uFE0F ", m("strong", null, awayMatches.length), " fuera")), playedMatches.length > 0 && m("div", {
      className: "CalendarMonthView-statsItem CalendarMonthView-statsItem--results"
    }, m("span", {
      className: "badge-win"
    }, wins, "V"), m("span", {
      className: "badge-draw"
    }, draws, "E"), m("span", {
      className: "badge-loss"
    }, losses, "D")));
  }
  selectMatch(match) {
    if (!match) return;
    this.selectedMatch = match;
    this.lastSeenPropMatchId = String(match.id());
    if (this.attrs.onSelectMatch) {
      this.attrs.onSelectMatch(match);
    }
    m.redraw();
    setTimeout(() => {
      const el = document.getElementById("calendar-inspector-".concat(match.id()));
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    }, 50);
  }
  renderCalendarGrid(matchesInMonth) {
    const lang = this.getLang();
    const weekdays = WEEKDAYS[lang] || WEEKDAYS.es;
    const weekdaysFull = WEEKDAYS_FULL[lang] || WEEKDAYS_FULL.es;
    const firstDay = new Date(this.currentYear, this.currentMonth, 1);
    const startOffset = (firstDay.getDay() + 6) % 7; // Monday = 0
    const daysInMonth = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
    const prevMonthDays = new Date(this.currentYear, this.currentMonth, 0).getDate();

    // Index matches in month by Day Number (1..31)
    const matchesByDay = {};
    matchesInMonth.forEach(m => {
      const d = this.getMatchDateObj(m);
      if (d) {
        const dayNum = d.getDate();
        if (!matchesByDay[dayNum]) {
          matchesByDay[dayNum] = [];
        }
        matchesByDay[dayNum].push(m);
      }
    });

    // Compute cells
    const cells = [];
    const now = new Date();
    const isCurrentMonthReal = now.getFullYear() === this.currentYear && now.getMonth() === this.currentMonth;
    const realDayToday = now.getDate();

    // Previous month padding
    for (let i = startOffset - 1; i >= 0; i--) {
      const prevDayNum = prevMonthDays - i;
      cells.push({
        day: prevDayNum,
        isOtherMonth: true,
        isPrevMonth: true,
        isToday: false,
        matches: []
      });
    }

    // Current month days
    for (let d = 1; d <= daysInMonth; d++) {
      cells.push({
        day: d,
        isOtherMonth: false,
        isToday: isCurrentMonthReal && d === realDayToday,
        matches: matchesByDay[d] || []
      });
    }

    // Next month padding to finish row (7 cols)
    const totalSoFar = cells.length;
    const remainder = totalSoFar % 7;
    const paddingNext = remainder === 0 ? 0 : 7 - remainder;
    for (let n = 1; n <= paddingNext; n++) {
      cells.push({
        day: n,
        isOtherMonth: true,
        isNextMonth: true,
        isToday: false,
        matches: []
      });
    }
    return m("div", {
      className: "CalendarMonthView-gridContainer",
      role: "grid"
    }, m("div", {
      className: "CalendarMonthView-weekdaysRow",
      role: "row"
    }, weekdays.map((name, idx) => m("div", {
      className: "CalendarMonthView-weekdayCell",
      role: "columnheader",
      title: weekdaysFull[idx]
    }, m("span", {
      className: "weekday-abbr"
    }, name)))), m("div", {
      className: "CalendarMonthView-daysGrid"
    }, cells.map((cell, idx) => {
      const hasMatches = cell.matches && cell.matches.length > 0;
      const firstMatch = hasMatches ? cell.matches[0] : null;
      const isMatchSelected = firstMatch && this.selectedMatch && String(firstMatch.id()) === String(this.selectedMatch.id());
      return m("div", {
        className: "CalendarMonthView-dayCell ".concat(cell.isOtherMonth ? 'is-other-month' : '', " ").concat(cell.isToday ? 'is-today' : '', " ").concat(hasMatches ? 'has-matches' : '', " ").concat(isMatchSelected ? 'is-selected' : ''),
        role: "gridcell",
        onclick: () => {
          if (hasMatches) {
            this.selectMatch(firstMatch);
          }
        }
      }, m("div", {
        className: "CalendarMonthView-dayNumber"
      }, m("span", {
        className: "num"
      }, cell.day), cell.isToday && m("span", {
        className: "today-chip"
      }, "Hoy")), hasMatches && m("div", {
        className: "CalendarMonthView-dayMatches"
      }, cell.matches.map(matchItem => m("div", {
        onclick: e => {
          e.stopPropagation();
          this.selectMatch(matchItem);
        },
        style: "cursor: pointer;"
      }, this.renderMatchInCell(matchItem)))));
    })));
  }
  renderMatchInCell(matchItem) {
    const athleticName = app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Athletic';
    const isLocal = typeof matchItem.isLocal === 'function' ? matchItem.isLocal() : true;
    const rivalObj = matchItem.rival ? matchItem.rival() : null;
    const opponentName = rivalObj ? rivalObj.name() : typeof matchItem.opponent === 'function' ? matchItem.opponent() : 'Rival';
    const rivalShield = rivalObj && typeof rivalObj.escudo === 'function' ? formatShieldUrl(rivalObj.escudo()) : null;
    const comp = typeof matchItem.competition === 'function' ? matchItem.competition() : null;
    const compColor = comp && typeof comp.color === 'function' && comp.color() ? comp.color() : '#ee2524';
    const compShort = comp && typeof comp.shortName === 'function' && comp.shortName() ? comp.shortName() : comp && typeof comp.name === 'function' ? comp.name() : null;
    const compIcon = comp && typeof comp.iconUrl === 'function' ? comp.iconUrl() : null;
    const jornadaLabel = typeof matchItem.jornada === 'function' && matchItem.jornada() ? matchItem.jornada() : null;
    const score = typeof matchItem.getScore === 'function' ? matchItem.getScore() : null;
    const isPlaceholder = this.attrs.isPlaceholderTime(matchItem.matchDate());
    const tvChannel = typeof matchItem.tvChannel === 'function' ? matchItem.tvChannel() : null;

    // Kick-off time
    let timeStr = '';
    if (typeof matchItem.matchDate === 'function' && matchItem.matchDate()) {
      const d = dayjs(matchItem.matchDate());
      timeStr = isPlaceholder ? 'Horario por confirmar' : d.format('HH:mm') + ' h';
    }
    const outcome = this.attrs.getMatchOutcome(matchItem);
    const outcomeClass = outcome ? "outcome-".concat(outcome) : '';
    return m("div", {
      className: "CalendarMonthView-cellCard ".concat(outcomeClass),
      title: "".concat(isLocal ? athleticName : opponentName, " vs ").concat(isLocal ? opponentName : athleticName),
      onclick: e => {
        if (e && e.stopPropagation) e.stopPropagation();
        this.selectMatch(matchItem);
      }
    }, m("div", {
      className: "cellCard-top"
    }, comp && m("span", {
      className: "cellCard-comp",
      style: "color: ".concat(compColor, "; background: ").concat(compColor, "1a; border-color: ").concat(compColor, "33;")
    }, compIcon && m("img", {
      src: compIcon,
      alt: "",
      className: "cellCard-compIcon"
    }), m("span", null, compShort)), jornadaLabel && m("span", {
      className: "cellCard-jornada"
    }, jornadaLabel), m("span", {
      className: "cellCard-venue ".concat(isLocal ? 'is-home' : 'is-away')
    }, isLocal ? '🏠 San Mamés' : '✈️ Fuera')), m("div", {
      className: "cellCard-middle"
    }, rivalShield ? m("img", {
      src: rivalShield,
      alt: opponentName,
      className: "cellCard-shield"
    }) : m("i", {
      className: "fas fa-shield-alt cellCard-shieldFallback"
    }), m("span", {
      className: "cellCard-opponent",
      title: opponentName
    }, opponentName)), m("div", {
      className: "cellCard-bottom"
    }, score ? m("span", {
      className: "cellCard-score ".concat(outcomeClass),
      style: this.attrs.getScoreBadgeStyle(matchItem)
    }, score) : m("div", {
      className: "cellCard-timeBlock"
    }, m("span", {
      className: "cellCard-time"
    }, m("i", {
      className: isPlaceholder ? 'far fa-calendar-alt' : 'far fa-clock'
    }), m("span", null, isPlaceholder ? 'Por conf.' : timeStr)), tvChannel && m("span", {
      className: "cellCard-tv",
      title: tvChannel
    }, m("i", {
      className: "fas fa-tv"
    }), " ", tvChannel))));
  }
  renderMatchInspector() {
    if (!this.selectedMatch) return null;
    const match = this.selectedMatch;
    const mId = String(match.id());
    const athleticName = app.forum.attribute('nagusiMatchRatingsPrimaryTeamName') || 'Athletic Club';
    const isLocal = typeof match.isLocal === 'function' ? match.isLocal() : true;
    const rivalObj = match.rival ? match.rival() : null;
    const opponentName = rivalObj ? rivalObj.name() : typeof match.opponent === 'function' ? match.opponent() : 'Rival';
    const athleticTeam = match.team ? match.team() : null;
    const defaultClubShield = athleticName.includes('Real Sociedad') ? '/assets/extensions/nagusi-match-ratings/escudos/real-sociedad.png' : '/assets/extensions/nagusi-match-ratings/escudos/athletic-club.png';
    const athleticShield = formatShieldUrl(athleticTeam && typeof athleticTeam.logoUrl === 'function' ? athleticTeam.logoUrl() : null) || defaultClubShield;
    const rivalShield = rivalObj && typeof rivalObj.escudo === 'function' ? formatShieldUrl(rivalObj.escudo()) : null;
    const localName = isLocal ? athleticName : opponentName;
    const visitorName = isLocal ? opponentName : athleticName;
    const localShield = isLocal ? athleticShield : rivalShield;
    const visitorShield = isLocal ? rivalShield : athleticShield;
    const score = typeof match.getScore === 'function' ? match.getScore() : null;
    const outcome = this.attrs.getMatchOutcome(match);
    const outcomeBadgeStyle = this.attrs.getScoreBadgeStyle(match);
    const comp = typeof match.competition === 'function' ? match.competition() : null;
    const compColor = comp && typeof comp.color === 'function' && comp.color() ? comp.color() : '#ee2524';
    const compName = comp && typeof comp.name === 'function' ? comp.name() : null;
    const compIcon = comp && typeof comp.iconUrl === 'function' ? comp.iconUrl() : null;
    const jornadaLabel = typeof match.jornada === 'function' ? match.jornada() : null;
    const fullDateStr = this.attrs.formatMatchDate(match.matchDate(), 'long');
    const tvChannel = typeof match.tvChannel === 'function' ? match.tvChannel() : null;
    const referee = typeof match.referee === 'function' ? match.referee() : null;
    const varReferee = typeof match.varReferee === 'function' ? match.varReferee() : null;
    const attendance = typeof match.attendance === 'function' ? match.attendance() : null;
    const hasPre = typeof match.previewUrl === 'function' && match.previewUrl() || typeof match.pressConferenceUrl === 'function' && match.pressConferenceUrl() || typeof match.callupUrl === 'function' && match.callupUrl();
    const hasPost = typeof match.postPressConferenceUrl === 'function' && match.postPressConferenceUrl() || typeof match.highlightsUrl === 'function' && match.highlightsUrl() || typeof match.fullMatchUrl === 'function' && match.fullMatchUrl();
    const hasGoals = typeof match.goalEvents === 'function' && Array.isArray(match.goalEvents()) && match.goalEvents().length > 0;
    const hasNotes = typeof match.notesHtml === 'function' && match.notesHtml();
    const seasonSlug = this.attrs.selectedSeasonName ? this.attrs.selectedSeasonName.replace('/', '-') : '';
    return m("div", {
      className: "CalendarMonthView-inspector",
      id: "calendar-inspector-".concat(mId)
    }, m("div", {
      className: "inspector-header"
    }, m("div", {
      className: "inspector-header-left"
    }, comp && m("span", {
      className: "inspector-compBadge",
      style: "background: ".concat(compColor, "18; color: ").concat(compColor, "; border: 1px solid ").concat(compColor, "33;")
    }, compIcon && m("img", {
      src: compIcon,
      alt: "",
      className: "inspector-compIcon"
    }), m("span", null, compName)), jornadaLabel && m("span", {
      className: "inspector-jornadaBadge"
    }, jornadaLabel), m("span", {
      className: "inspector-venueBadge"
    }, m("i", {
      className: isLocal ? "fas fa-home" : "fas fa-plane"
    }), m("span", null, isLocal ? 'Estadio San Mamés (Bilbao)' : 'A domicilio (Fuera)'))), m("button", {
      type: "button",
      className: "inspector-closeBtn",
      onclick: () => {
        this.selectedMatch = null;
        m.redraw();
      },
      title: "Cerrar detalles"
    }, m("i", {
      className: "fas fa-times"
    }))), m("div", {
      className: "inspector-scoreboard"
    }, m("div", {
      className: "inspector-team inspector-team--local"
    }, localShield && m("img", {
      src: localShield,
      alt: localName,
      className: "inspector-shield"
    }), m("span", {
      className: "inspector-teamName"
    }, localName)), m("div", {
      className: "inspector-scoreCenter"
    }, score ? m("div", {
      className: "inspector-scoreValue",
      style: outcomeBadgeStyle
    }, score) : m("div", {
      className: "inspector-pendingStatus"
    }, m("span", {
      className: "inspector-timeLabel"
    }, fullDateStr)), outcome && m("span", {
      className: "inspector-outcomeTag outcome-".concat(outcome)
    }, outcome === 'win' ? 'Victoria' : outcome === 'loss' ? 'Derrota' : 'Empate')), m("div", {
      className: "inspector-team inspector-team--visitor"
    }, visitorShield && m("img", {
      src: visitorShield,
      alt: visitorName,
      className: "inspector-shield"
    }), m("span", {
      className: "inspector-teamName"
    }, visitorName))), (tvChannel || referee || varReferee || attendance) && m("div", {
      className: "inspector-infoStrip"
    }, tvChannel && m("div", {
      className: "inspector-infoItem tv"
    }, m("i", {
      className: "fas fa-tv"
    }), m("span", null, tvChannel)), referee && m("div", {
      className: "inspector-infoItem referee"
    }, m("i", {
      className: "fas fa-balance-scale"
    }), m("span", null, "\xC1rbitro: ", m("strong", null, referee))), varReferee && m("div", {
      className: "inspector-infoItem var"
    }, m("i", {
      className: "fas fa-desktop"
    }), m("span", null, "VAR: ", m("strong", null, varReferee))), attendance && m("div", {
      className: "inspector-infoItem attendance"
    }, m("i", {
      className: "fas fa-users"
    }), m("span", null, "Asistencia: ", m("strong", null, new Intl.NumberFormat().format(attendance))))), m("div", {
      className: "inspector-actions"
    }, m("a", {
      href: "/la-bolilla/".concat(seasonSlug, "/votar"),
      className: "Button Button--primary inspector-actionBtn"
    }, m("i", {
      className: "fas fa-futbol"
    }), m("span", null, "La Bolilla")), m("a", {
      href: "/11-aldeanos/".concat(seasonSlug, "/pronosticar"),
      className: "Button Button--primary inspector-actionBtn"
    }, m("i", {
      className: "fas fa-tshirt"
    }), m("span", null, "11 Aldeanos")), this.attrs.onSwitchToList && m("button", {
      type: "button",
      className: "Button Button--secondary inspector-actionBtn",
      onclick: () => this.attrs.onSwitchToList(mId)
    }, m("i", {
      className: "fas fa-th-list"
    }), m("span", null, "Ver en listado completo"))), (hasPre || hasPost) && m("div", {
      className: "inspector-linksSection"
    }, hasPre && m("div", {
      className: "inspector-linksGroup"
    }, m("span", {
      className: "inspector-linksGroup-title"
    }, "\uD83D\uDCCC Previa"), m("div", {
      className: "inspector-linksGroup-items"
    }, typeof match.previewUrl === 'function' && match.previewUrl() && m("a", {
      href: match.previewUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "inspector-linkPill"
    }, m("i", {
      className: "fas fa-newspaper",
      style: "color: #f59e0b;"
    }), " Previa del partido"), typeof match.pressConferenceUrl === 'function' && match.pressConferenceUrl() && m("a", {
      href: match.pressConferenceUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "inspector-linkPill"
    }, m("i", {
      className: "fas fa-video",
      style: "color: #ec4899;"
    }), " Rueda de prensa"), typeof match.callupUrl === 'function' && match.callupUrl() && m("a", {
      href: match.callupUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "inspector-linkPill"
    }, m("i", {
      className: "fas fa-list-ol",
      style: "color: #10b981;"
    }), " Convocatoria"))), hasPost && m("div", {
      className: "inspector-linksGroup"
    }, m("span", {
      className: "inspector-linksGroup-title"
    }, "\uD83C\uDFAC Post-partido"), m("div", {
      className: "inspector-linksGroup-items"
    }, typeof match.highlightsUrl === 'function' && match.highlightsUrl() && m("a", {
      href: match.highlightsUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "inspector-linkPill"
    }, m("i", {
      className: "fas fa-play-circle",
      style: "color: #ef4444;"
    }), " Resumen"), typeof match.postPressConferenceUrl === 'function' && match.postPressConferenceUrl() && m("a", {
      href: match.postPressConferenceUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "inspector-linkPill"
    }, m("i", {
      className: "fas fa-microphone",
      style: "color: #a855f7;"
    }), " Rueda de prensa post"), typeof match.fullMatchUrl === 'function' && match.fullMatchUrl() && m("a", {
      href: match.fullMatchUrl(),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "inspector-linkPill"
    }, m("i", {
      className: "fas fa-film",
      style: "color: #3b82f6;"
    }), " Partido completo")))), hasGoals && m("div", {
      className: "inspector-goalsSection"
    }, m("span", {
      className: "inspector-sectionTitle"
    }, "\u26BD Goles del Partido"), m("div", {
      className: "inspector-goalsList"
    }, match.goalEvents().map(g => {
      const pId = g.player_id || g.playerId;
      const playerObj = pId ? (this.attrs.players || []).find(p => String(p.id()) === String(pId)) : null;
      const photo = playerObj && typeof playerObj.photoUrl === 'function' ? playerObj.photoUrl() : null;
      const isGoalLocal = g.team === 'local';
      const goalTeamName = isGoalLocal ? localName : visitorName;
      const goalTeamShield = isGoalLocal ? localShield : visitorShield;
      return m("div", {
        className: "inspector-goalItem"
      }, m("span", {
        className: "inspector-goalMinute"
      }, g.minute), m("span", {
        className: "inspector-goalTeam"
      }, goalTeamShield && m("img", {
        src: goalTeamShield,
        alt: ""
      }), m("span", null, goalTeamName)), photo && m("img", {
        src: photo,
        alt: "",
        className: "inspector-goalPlayerPhoto"
      }), m("span", {
        className: "inspector-goalScorer"
      }, g.name || (playerObj ? playerObj.name() : 'Jugador'), g.is_own_goal || g.isOwnGoal ? ' (p.p.)' : ''));
    }))), hasNotes && m("div", {
      className: "inspector-notesSection"
    }, m("span", {
      className: "inspector-sectionTitle"
    }, "\uD83D\uDCDD ", app.translator.trans('nagusi-match-ratings.forum.calendar.notes_label')), m("div", {
      className: "inspector-notesBody"
    }, this.attrs.renderNotesHtml(match.notesHtml()))));
  }
  view() {
    const matches = this.attrs.matches || [];
    const matchesInMonth = this.getMatchesForYearMonth(this.currentYear, this.currentMonth, matches);
    const title = this.getMonthTitle(this.currentYear, this.currentMonth);
    const monthsList = this.getSeasonMonthsList();
    return m("div", {
      className: "CalendarMonthView"
    }, this.renderMonthsQuickBar(), m("div", {
      className: "CalendarMonthView-navHeader"
    }, m("div", {
      className: "CalendarMonthView-navControls"
    }, m("button", {
      type: "button",
      className: "CalendarMonthView-navBtn prev",
      onclick: e => {
        e.preventDefault();
        e.stopPropagation();
        this.prevMonth();
      },
      title: "Mes anterior",
      "aria-label": "Mes anterior"
    }, m("i", {
      className: "fas fa-chevron-left"
    })), m("div", {
      className: "CalendarMonthView-monthTitleWrap"
    }, m("select", {
      className: "CalendarMonthView-monthSelect",
      value: "".concat(this.currentYear, "-").concat(this.currentMonth),
      onchange: e => {
        const parts = e.target.value.split('-');
        this.setYearMonth(parseInt(parts[0], 10), parseInt(parts[1], 10));
      },
      title: "Seleccionar mes"
    }, monthsList.map(item => m("option", {
      value: "".concat(item.year, "-").concat(item.month),
      selected: item.year === this.currentYear && item.month === this.currentMonth
    }, this.getMonthTitle(item.year, item.month), " ", item.count > 0 ? "(".concat(item.count, ")") : ''))), m("h3", {
      className: "CalendarMonthView-monthTitle"
    }, m("i", {
      className: "far fa-calendar-alt",
      style: "margin-right: 8px; color: #ee2524;"
    }), m("span", null, title), m("i", {
      className: "fas fa-chevron-down CalendarMonthView-monthDropdownIcon"
    }))), m("button", {
      type: "button",
      className: "CalendarMonthView-navBtn next",
      onclick: e => {
        e.preventDefault();
        e.stopPropagation();
        this.nextMonth();
      },
      title: "Mes siguiente",
      "aria-label": "Mes siguiente"
    }, m("i", {
      className: "fas fa-chevron-right"
    }))), m("div", {
      className: "CalendarMonthView-navActions"
    }, m("button", {
      type: "button",
      className: "Button Button--secondary CalendarMonthView-jumpBtn",
      onclick: () => this.goToToday()
    }, m("i", {
      className: "far fa-dot-circle",
      style: "color: #ee2524; margin-right: 6px;"
    }), m("span", null, "Hoy")), this.attrs.featuredNextMatch && m("button", {
      type: "button",
      className: "Button Button--secondary CalendarMonthView-jumpBtn",
      onclick: () => this.goToNextMatch(),
      title: "Ir al pr\xF3ximo partido"
    }, m("i", {
      className: "fas fa-forward",
      style: "color: #10b981; margin-right: 6px;"
    }), m("span", null, "Pr\xF3ximo partido")))), this.renderMonthStats(matchesInMonth), this.renderCalendarGrid(matchesInMonth), this.renderMatchInspector());
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/calendar/CalendarMonthView', CalendarMonthView);